<template>
    <div class="md-layout">

        <div class="md-layout-item md-small-size-100">
            <form @submit.prevent="update">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-green">
                        <div class="card-icon md-xsmall-size">
                            <md-icon>face</md-icon>
                        </div>
                        <h5 class="title">Add Institution</h5>
                        <h5 class="title">Personal Details </h5>
                        <hr>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                            <md-button @click="goToView(labourer.id)" class="md-primary md-dense">
                                View Details
                            </md-button>
                        </div>
                    </md-card-header>
                    <md-card-content>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Profile Photo
                            </label>
                            <div class="md-layout-item">
                                <div class="file-input">
                                    <div v-if="image">
                                        <div class="image-container">
                                            <img :src="image" />
                                        </div>
                                    </div>
                                    <div class="image-container" v-else>
                                        <img :src="default_image" />
                                    </div>
                                    <div class="button-container">
                                        <md-button
                                                class="md-danger md-round"
                                                @click="removeImage"
                                                v-if="image"
                                        >
                                            <i class="fa fa-times" />
                                            Remove
                                        </md-button>
                                        <md-button class="md-success md-fileinput">
                                            <template v-if="!image">Select image</template>
                                            <template v-else>Change</template>
                                            <input type="file" @change="onFileChange" />
                                        </md-button>
                                    </div>
                                </div>
                                <md-field class="md-invalid">
                                    <validation-error :errors="apiValidationErrors.attachment" />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                First Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.first_name"/>
                                    <validation-error :errors="apiValidationErrors.first_name"/>
                                </md-field>
                            </div>
                        </div>
                        <br>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Middle Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.middle_name"/>
                                    <validation-error :errors="apiValidationErrors.middle_name"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Last Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.last_name"/>
                                    <validation-error :errors="apiValidationErrors.last_name"/>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Birth Date
                            </label>
                            <div class="md-layout-item">
                                <md-datepicker v-model="labourer.birth_date" md-immediately />
                                <validation-error :errors="apiValidationErrors.birth_date" />
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Birth Certificate  Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.birth_certificate_number"/>
                                    <validation-error :errors="apiValidationErrors.birth_certificate_number"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Tribe
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.tribe"/>
                                    <validation-error :errors="apiValidationErrors.tribe"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                NIDA Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.nida_number"/>
                                    <validation-error :errors="apiValidationErrors.nida_number"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Gender
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="labourer.gender"
                                        deselect-label="Can't remove this value"
                                        track-by="name"
                                        label=""
                                        placeholder="Select  Gender"
                                        :options="gender_options"
                                        :allow-empty="false"
                                >
                                </select-input>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Religion
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="labourer.religion_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label=""
                                        placeholder="Select  Religion"
                                        :options="religions"
                                        :allow-empty="false"
                                >
                                </select-input>
                            </div>
                        </div>


                    </md-card-content>
                    <md-card-header class="md-card-header-icon md-card-header-green">
                        <div class="card-icon md-xsmall-size">
                            <md-icon>email</md-icon>
                        </div>
                        <h5 class="title">Contact Details</h5>
                        <hr>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Email
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.email"/>
                                    <validation-error :errors="apiValidationErrors.email"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Phone Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.phone_number"/>
                                    <validation-error :errors="apiValidationErrors.phone_number"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Address
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.address"/>
                                    <validation-error :errors="apiValidationErrors.address"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Region
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="labourer.region_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label=" "
                                        placeholder="Select Region"
                                        :options="regions"
                                        :allow-empty="false"
                                >
                                </select-input>
                            </div>
                        </div>
                        <div class="md-layout"   v-if="labourer.region_id">
                            <label class="md-layout-item md-size-25 md-form-label">
                                District
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-if="labourer.region_id"
                                        v-model="labourer.district_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label=" "
                                        placeholder="Select District"
                                        :options="districts"
                                        :allow-empty="false"
                                >
                                </select-input>
                            </div>
                        </div>
                        <div class="md-layout"  v-if="labourer.district_id">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Ward
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-if="labourer.district_id"
                                        v-model="labourer.ward_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="Districts"
                                        placeholder="Select Wards"
                                        :options="wards"
                                        :allow-empty="false"
                                >
                                </select-input>
                            </div>
                        </div>
                        <div class="md-layout"  v-if="labourer.ward_id">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Village
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-if="labourer.ward_id"
                                        v-model="labourer.village_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="Village / Street"
                                        placeholder="Select Street"
                                        :options="villages"
                                        :allow-empty="false">
                                </select-input>
                            </div>
                        </div>
                    </md-card-content>
                    <md-card-header class="md-card-header-icon md-card-header-green">
                        <div class="card-icon md-xsmall-size">
                            <md-icon>face</md-icon>
                        </div>
                        <h5 class="title">Labourer Details</h5>
                        <hr>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Labour Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="labourer.labourer_number"/>
                                    <validation-error :errors="apiValidationErrors.labourer_number"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Skilled
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="labourer.skilled"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label=""
                                        placeholder="Skilled ?"
                                        :options="skills_config_options"
                                        :allow-empty="false"
                                >
                                </select-input>
                            </div>
                        </div>
                        <div class="md-layout spacing"  v-if="labourer.skilled =='1'">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Skill
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-if="labourer.skilled"
                                        v-model="labourer.skill_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label=" "
                                        placeholder="Select Skills"
                                        :options="skillsLists"
                                        :allow-empty="false"
                                >
                                </select-input>
                            </div>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Assign Port of Operation
                                </label>
                                <div class="md-layout-item">
                                    <select-input
                                            v-model="labourer.port.id"
                                            deselect-label="Can't remove this value"
                                            track-by="id"
                                            label="Port"
                                            placeholder="Select Port"
                                            :options="ports"
                                            :allow-empty="false">
                                    </select-input>
                                </div>
                            </div>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Assign Department of Operation
                                </label>
                                <div class="md-layout-item">
                                    <select-input
                                            v-model="labourer.department.id"
                                            deselect-label="Can't remove this value"
                                            track-by="id"
                                            label="Department"
                                            placeholder="Select Department"
                                            :options="departments"
                                            :allow-empty="false">
                                    </select-input>
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Labourer</md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInput from '../../../components/Inputs/SelectInput';

export default {
    components: {
        SelectInput,
        ValidationError,
    },

    mixins: [formMixin],

    data: () => ({
        labourer: {
            type: 'labourers',
            // first_name: null,
            // middle_name: null,
            // last_name: null,
            // address: null,
            // phone_number: null,
            // email: null,
            // nida_number: null,
            // region_id: null,
            // district_id: null,
            // ward_id: null,
            // village_id: null,
            // skilled: null,
            // tribe: null,
            // labourer_number: null,
            // skill_id:null,
            // image:null,
            port:{
                type:"ports",
                id:null,
            },
            department:{
                type:"departments",
                id:null,
            }
        },
        ports:[],
        departments:[],
        image: null,
        file: null,
        skills_config_options: [
            { id: '1', 'name': 'Yes' },
            { id: '0', 'name': 'No' }
        ],
        gender_options: [
            { id: 'Female', 'name': 'Female' },
            { id: 'Male', 'name': 'Male' }
        ],
        default_image: process.env.VUE_APP_BASE_URL + '/img/placeholder.jpg',
        religions: [],
        selected: [],
        skillsLists: [],
        neighborhoods: [],
        villages: [],
        wards: [],
        districts: [],
        regions: [],
    }),
    created () {
      this.get();
        this.fetchData();
        this.regionsData();
        this.skillData();
        this.port();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('labourers/get', id);
                this.labourer = this.$store.getters['labourers/labourer']
              if(!this.labourer.port){
                this.labourer.port = {
                  type: 'ports',
                  id: null,
                }
              }
                console.log(this.labourer);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        async update () {
            this.labourer.birth_date = moment(this.labourer.birth_date).format('YYYY-MM-DD');
            //  this.labourer.port_id=
            try {
                await this.$store.dispatch('labourers/update',this.labourer);

                // if (!!this.file) {
                //     // upload image and get image url
                //        await this.$store.dispatch("labourers/upload", {
                //         labourer: this.labourer,
                //         image: this.file,
                //       });
                //     this.labourer.image = await this.$store.getters["labourers/url"];
                //     await this.$store.dispatch("labourers/update", this.labourer);
                //     this.labourer = await this.$store.getters["labourers/labourer"];
                // }
              this.notifySuccess('Labour updated successfully.')
               this.goToView(this.labourer.id);
            } catch (e) {
                console.log(e);
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    console.log(e);
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        async port () {
            await this.$store.dispatch('ports/list');
            this.ports = this.$store.getters['ports/list'];

            await this.$store.dispatch('departments/list');
            this.departments = this.$store.getters['departments/list'];
        },

        handlePreview (file) {
            this.model.imageUrl = URL.createObjectURL(file.raw);
        },
        onFileChange (e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.createImage(files[0]);
        },
        validate () {
            return this.$refs.form.validate().then(res => {
                this.$emit('on-validated', res);
                console.log(res);
                return res;
            });
        },
        createImage (file) {
            var reader = new FileReader();
            var vm = this;
            reader.onload = e => {
                vm.image = e.target.result;
                this.labourer.image = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        async fetchData () {
            await this.$store.dispatch('religions/list');
            this.religions = this.$store.getters['religions/list'];
        },
        async regionsData () {
            await this.$store.dispatch('regions/list');
            this.regions = this.$store.getters['regions/list'];
            await this.$store.dispatch('districts/list');
            this.districts = this.$store.getters['districts/list'];
        },
        async skillData () {
            await this.$store.dispatch('skills/list');
            this.skillsLists = this.$store.getters['skills/list'];
        },

        goBack () {
            this.$router.push({ name: 'Labourers List' });
        },
      goToView: function(id) {
        this.$router.push({ name: 'View Labourer', params: { id: id } });
      },
    },

    computed: {
        village () {
            return this.labourer.village_id;
        },
        ward () {
            return this.labourer.ward_id;
        },
        district () {
            return this.labourer.district_id;
        },
        region () {
            return this.labourer.region_id;
        },
    },
    watch: {
        async region () {
            await this.$store.dispatch('regions/get', this.labourer.region_id);
            let region = this.$store.getters['regions/region'];
            this.districts = region.districts;
        },

        async district () {
            await this.$store.dispatch('districts/get', this.labourer.district_id);
            let district = this.$store.getters['districts/district'];
            this.wards = district.wards;
        },

        async ward () {
            await this.$store.dispatch('wards/get', this.labourer.ward_id);
            let ward = this.$store.getters['wards/ward'];
            this.villages = ward.villages;
        },

        async village () {
            await this.$store.dispatch('villages/get', this.labourer.village_id);
            this.neighborhoods = this.$store.getters['villages/village'].neighborhoods;
        },
    }
};
</script>
<style lang="scss" scoped>
    .spacing {
        padding-bottom: 1rem;
    }

    .md-checkbox,
    .md-radio {
        margin-top: 15px;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

    .md-radio .md-radio-container {
        margin-left: 5px;
        position: relative;
        left: -3px;
    }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding-left: 0;
        padding-top: 10px;
        min-height: 150px;
    }

    .md-field:after,
    .md-field:before {
        bottom: 10px !important;
    }
    .ck-editor__editable {
        min-height: 200px;
        width: auto;
    }
</style>
